import React from 'react';

import { WHY_CONTENT, WHY_FEATURES } from '../WhyChooseUs/WhyChooseUs.js';
import './Offerings.css';

const splitTitle = (title) => {
  const words = title.split(' ');
  const firstTwo = title.slice(0, 2);
  const lastWord = words[words.length - 1];
  const middle = title.slice(2, title.length - lastWord.length);
  return (
    <>
      <span className="of__title-primary">{firstTwo}</span>
      {middle}
      <span className="of__title-gradient">{lastWord}</span>
    </>
  );
};

const CARD_IMAGES = [
  'https://images.unsplash.com/photo-1501785888041-af3ef285b470?q=80&w=600&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1580140204263-0adff7dc519f?q=80&w=600&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1516484681091-7d83961805f4?q=80&w=600&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1533497394934-b33cd9695ba9?q=80&w=600&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1618165220283-e85246c4171c?q=80&w=600&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1560550356-3cdd74bca5e8?q=80&w=600&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=600&auto=format&fit=crop',
];

const Offerings = () => {
  return (
    <section className="of rt__section">
      <div className="rt__container">
        <div className="of__header" data-aos="fade-up">
          <h2 className="of__heading">
            Designed for <span className="text-gradient">Dependability</span>
          </h2>
          <p className="of__subheading">{WHY_CONTENT.subheading}</p>
        </div>

        <div className="of__string">
          <svg className="of__string-svg" viewBox="0 0 1200 60" preserveAspectRatio="none">
            <path d="M0 10 Q600 55 1200 10" stroke="#8B7355" strokeWidth="4" fill="none" strokeLinecap="round" />
          </svg>
          <div className="of__clips">
            {(() => {
              const elements = [];
              elements.push(
                <svg className="of__string-svg--mobile" viewBox="0 0 300 40" preserveAspectRatio="none" key="ms1">
                  <path d="M2 5 Q150 35 298 5" stroke="#8B7355" strokeWidth="4" fill="none" strokeLinecap="round" />
                </svg>
              );
              WHY_FEATURES.forEach((feature, index) => {
                elements.push(
                  <div key={feature.id} className="of__card" data-aos="fade-up" data-aos-delay={index * 80}>
                    <div className="of__clip" />
                    <div className="of__card-inner">
                      <div className="of__card-img-wrap">
                        <img src={CARD_IMAGES[index]} alt={feature.title} loading="lazy" />
                      </div>
                      <h3 className="of__feature-title">{splitTitle(feature.title)}</h3>
                    </div>
                  </div>
                );
                if (index === 1 || index === 3) {
                  elements.push(
                    <svg className="of__string-svg--mobile" viewBox="0 0 300 40" preserveAspectRatio="none" key={`ms${index === 1 ? 2 : 3}`}>
                      <path d="M2 5 Q150 35 298 5" stroke="#8B7355" strokeWidth="4" fill="none" strokeLinecap="round" />
                    </svg>
                  );
                }
              });
              return elements;
            })()}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Offerings;
